import api from './api';

export const selectStressById = async payload => {
  const response = await api.get(`stress/${payload}`);
  return response.data;
};

export const selectStressByIdOLD = async payload => {
  const response = await api.get(`stress/old/${payload}`);
  return response.data;
};

export const fetchStressByCod = codLaudo =>
  Number(codLaudo) > 81610
    ? selectStressById(codLaudo)
    : selectStressByIdOLD(codLaudo);

export const updateStressById = async payload => {
  const result = await api.put(`/stress/${payload.CODSTRESS}`, payload);
  return result;
};
